export default __webpack_public_path__ + "static/media/token-logo.35bba02f.png";